import { PartnerServices, VarmaPensionOrder } from "@salaxy/core";

import { SessionService } from "./SessionService";

/**
 * Varma pension service. Contains methods for getting order template, validating the order
 * and sending the order.
 */
export class VarmaPensionService {

    /**
     * For NG-dependency injection
     * @ignore
     */
    public static $inject = ["SessionService", "PartnerServices"];

    /** Current order  */
    private current: VarmaPensionOrder & { owner?: string | null };

    constructor(
        private sessionService: SessionService,
        private partnerServicesApi: PartnerServices,
    ) {
    }

    /** Lazy loading of current pension order template */
    public getCurrent(): VarmaPensionOrder {
        const getEmptyOrder = () => ({
            owner: null,
            orderer: {
                contact: {},
            },
            tyel: {},
            yel: {},
            validation: {},
            });
        if (this.sessionService.isSessionChecked && this.sessionService.isAuthenticated) {
              const owner = this.sessionService.session.currentAccount.owner;
              if (this.current?.owner != owner) {
                  this.current = getEmptyOrder();
                  this.current.owner = owner;
                  // trigger loading
                  this.partnerServicesApi.getNewVarmaPensionOrder().then((order) => {
                    this.current = { ...order, owner };
                  });
              }
        } else {
            this.current = null;
        }
        return this.current ??= getEmptyOrder();
    }

    /**
     * Sends order for processing.
     */
    public send(): Promise<VarmaPensionOrder> {
        const owner = this.sessionService.session.currentAccount.owner;
        return this.partnerServicesApi.sendVarmaPensionOrder(this.current).then((order) => {
            this.current = order;
            this.current.owner = owner;
            // refresh products
            return this.sessionService.checkSession().then ( () => {
                return  this.current;
            });
        });
    }

    /**
     * Validates the order.
     */
    public validate(): Promise<VarmaPensionOrder> {
      const owner = this.sessionService.session.currentAccount.owner;
      return this.partnerServicesApi.validateVarmaPensionOrder(this.current).then((order) => {
          this.current = order;
          this.current.owner = owner;
          return this.current;
      });
    }

    /**
     * Resets the current order.
     */
    public reset() {
        this.current = null;
    }
}
